import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { toast } from '../../utilities/appToast';
import { updateEstadoBancarioCbuSellerApi } from '../../api/axios';
import { getlistGestionDatosBancariosSellersTesoreria } from '../../actions/sellersActions';
import { getEstadoBancarioCbu } from '../../utilities/Seller/EstadoBancarioCbuSeller';
import BigSpinner from '../General/BigSpinner';
import { DropDownArrow, customStyle, filterSelectMenuPortalProps } from '../../template/CustomStyle';
import PropTypes from 'prop-types';
import SafeReactPaginate from '../General/SafeReactPaginate';
import '../General/AdminListCard.css';

class GestionDatosBancarios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listaDatosBancarios: [],
            isLoading: true,
            estado: null,
            currentPage: 1,
            pageSize: 10,
            totalRegistros: 0,
            estadosOptions: [
                { value: 1, label: "Pendiente" },
                { value: 2, label: "Aprobado" },
                { value: 3, label: "Rechazado" },
            ],
        };
    }

    componentDidMount() {
        this.setState(
            { estado: { value: 1, label: "Pendiente" } },
            () => this.cargarListaDatosBancarios()
        );
    }

    normalizeDatosBancariosList = (response) => {
        if (!response) return [];
        if (Array.isArray(response)) return response;

        const resultadoWrap = response?.resultado ?? response?.Resultado;
        if (resultadoWrap != null) {
            const fromWrap = this.normalizeDatosBancariosList(resultadoWrap);
            if (fromWrap.length > 0) return fromWrap;
        }

        if (Array.isArray(response?.datosBancarios)) return response.datosBancarios;
        if (Array.isArray(response?.DatosBancarios)) return response.DatosBancarios;
        if (Array.isArray(response?.listaDatosBancarios)) return response.listaDatosBancarios;
        if (Array.isArray(response?.ListaDatosBancarios)) return response.ListaDatosBancarios;
        if (Array.isArray(response?.datosBancariosSellers)) return response.datosBancariosSellers;
        if (Array.isArray(response?.DatosBancariosSellers)) return response.DatosBancariosSellers;
        if (Array.isArray(response?.elementos)) return response.elementos;
        if (Array.isArray(response?.Elementos)) return response.Elementos;
        if (Array.isArray(response?.content)) return response.content;
        if (Array.isArray(response?.Content)) return response.Content;
        if (Array.isArray(response?.data)) return response.data;
        if (response?.data && typeof response.data === "object") {
            return this.normalizeDatosBancariosList(response.data);
        }
        if (typeof response === "object") {
            // No usar el primer array genérico: suele ser "errores": [] y oculta la lista real.
            const skipArrayKeys = new Set([
                "errores",
                "Errores",
                "errors",
                "Errors",
                "mensajes",
                "Mensajes",
                "warnings",
                "Warnings",
            ]);
            const entries = Object.entries(response).filter(([key]) => !skipArrayKeys.has(key));
            const arrays = entries
                .filter(([, value]) => Array.isArray(value))
                .map(([, value]) => value);
            const nonEmpty = arrays.find((arr) => arr.length > 0);
            if (nonEmpty) return nonEmpty;

            for (const [, value] of entries) {
                if (value != null && typeof value === "object" && !Array.isArray(value)) {
                    const nested = this.normalizeDatosBancariosList(value);
                    if (nested.length > 0) return nested;
                }
            }
        }
        return [];
    };

    normalizeDatoBancario = (item) => ({
        ...item,
        id: item?.id ?? item?.Id ?? item?.idDatoBancario ?? item?.IdDatoBancario ?? item?.idSeller ?? item?.IdSeller ?? 0,
        seller: item?.seller ?? item?.Seller ?? item?.razonSocial ?? item?.RazonSocial ?? "-",
        cuit: item?.cuit ?? item?.Cuit ?? "-",
        nroCuenta: item?.nroCuenta ?? item?.NroCuenta ?? item?.numeroCuenta ?? item?.NumeroCuenta ?? "-",
        tipoCuenta: item?.tipoCuenta ?? item?.TipoCuenta ?? "-",
        cbu: item?.cbu ?? item?.Cbu ?? "-",
        banco: item?.banco ?? item?.Banco ?? "-",
        estado: item?.estado ?? item?.Estado ?? 0
    });

    tryParseTotalDesdeObjeto = (obj) => {
        if (!obj || typeof obj !== "object" || Array.isArray(obj)) return 0;
        const keys = [
            "total",
            "Total",
            "cantidadTotal",
            "CantidadTotal",
            "totalElementos",
            "TotalElementos",
            "totalRecords",
            "TotalRecords",
            "cantidadRegistros",
            "CantidadRegistros",
        ];
        for (const k of keys) {
            const raw = obj[k];
            if (raw === null || raw === undefined || raw === "") continue;
            const n = Number(raw);
            if (!Number.isNaN(n) && n >= 0) return n;
        }
        return 0;
    };

    extractTotalRegistros = (response, listaLength, currentPage, pageSize) => {
        const roots = [
            response,
            response?.resultado,
            response?.Resultado,
            response?.data,
            response?.Data,
        ].filter((x) => x && typeof x === "object" && !Array.isArray(x));

        for (const root of roots) {
            const n = this.tryParseTotalDesdeObjeto(root);
            if (n > 0) return n;
        }

        if (listaLength < pageSize) {
            return (currentPage - 1) * pageSize + listaLength;
        }
        return currentPage * pageSize + 1;
    };

    cargarListaDatosBancarios = async () => {
        const { estado, currentPage, pageSize } = this.state;
        this.setState({ isLoading: true });

        try {
            const paging = { page: currentPage, pageSize };
            const estadoValor =
                estado && estado.value != null ? estado.value : 1;
            const request = { estado: estadoValor, ...paging };

            const datos = await getlistGestionDatosBancariosSellersTesoreria(request);
            let datosBancarios = this.normalizeDatosBancariosList(datos);
            datosBancarios = datosBancarios.map(this.normalizeDatoBancario);
            const totalRegistros = this.extractTotalRegistros(
                datos,
                datosBancarios.length,
                currentPage,
                pageSize
            );

            this.setState({
                listaDatosBancarios: datosBancarios,
                totalRegistros,
                isLoading: false
            });
        } catch (error) {
            console.error(error);
            toast.error("No se pudieron cargar los datos bancarios.");
            this.setState({ isLoading: false });
        }
    };

    renderEstado = (estado) => {
        const texto = getEstadoBancarioCbu(estado).toUpperCase();
        let clase = "";

        switch (texto) {
            case "PENDIENTE":
                clase = "badge bg-secondary";
                break;
            case "APROBADO":
                clase = "badge bg-success";
                break;
            case "RECHAZADO":
                clase = "badge bg-danger";
                break;
            default:
                clase = "badge bg-dark";
        }

        return <span className={clase}>{texto}</span>;
    };

    aceptar = async (id) => {
        try {
            const request = {
                idUsuario: Number.parseInt(this.props.userId, 10) || 0,
                id: id,
                estado: 2
            };

            await updateEstadoBancarioCbuSellerApi(request);
            toast.success("Datos Bancarios Aprobados");
            await this.cargarListaDatosBancarios();

        } catch {
            toast.error("No se pudieron aprobar los datos bancarios");
        }
    };

    rechazar = async (id) => {
        try {
            const request = {
                idUsuario: Number.parseInt(this.props.userId, 10) || 0,
                id: id,
                estado: 3
            };

            await updateEstadoBancarioCbuSellerApi(request);
            toast.success("Datos Bancarios Rechazados");
            await this.cargarListaDatosBancarios();

        } catch {
            toast.error("No se pudieron rechazar los datos bancarios.");
        }
    };

    handleChangeEstado = (selected) => {
        this.setState({ estado: selected, currentPage: 1 }, () => {
            this.cargarListaDatosBancarios();
        });
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.setState({ currentPage: selectedPage }, () =>
            this.cargarListaDatosBancarios()
        );
    };

    render() {
        const { listaDatosBancarios, isLoading, totalRegistros, pageSize, currentPage } = this.state;
        const pageCount = Math.max(1, Math.ceil(totalRegistros / pageSize));

        return (
            <div className="container mt-4">

                <div className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded" style={{ background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)', borderLeft: '4px solid var(--rojo-megatone, #c00)' }}>
                    <div className="col-12">
                        <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Datos bancarios sellers</h4>
                        <p className="mb-0 mt-1 small text-muted">Revisión y gestión del estado de CBU y cuentas.</p>
                    </div>
                </div>

                <div className="card filter-card shadow-sm mb-4">
                    <div className="card-header bg-light py-2">
                        <h6 className="mb-0 fw-semibold text-dark">Filtros de búsqueda</h6>
                    </div>
                    <div className="card-body">
                        <div className="row align-items-end mt-2">

                        <div className="col-12 col-sm-5">
                            <label htmlFor="datosBancariosEstado" className="label-oscura">Estado</label>
                            <Select
                                id="datosBancariosEstado"
                                name="estado"
                                options={this.state.estadosOptions}
                                value={
                                    this.state.estado ??
                                    this.state.estadosOptions[0]
                                }
                                onChange={this.handleChangeEstado}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyle}
                                {...filterSelectMenuPortalProps}
                            />
                        </div>
                    </div>
                </div>
                </div>

                {isLoading && <BigSpinner message="Cargando datos bancarios..." />}
                {!isLoading && listaDatosBancarios.length === 0 ? (
                    <div className="card shadow-sm border-0">
                        <div className="card-body py-5 text-center text-muted">
                            No se encontraron datos
                        </div>
                    </div>
                ) : (
                    listaDatosBancarios.map(item => (
                        <div
                            key={item.id}
                            className="list-group-item hover-background-color mb-1 p-1"
                            style={{ background: "#fff" }}
                        >
                            <div className="row align-items-center">

                                <div className="col-md-3">
                                    <strong>{item.seller}</strong><br />
                                    <small>{item.cuit}</small>
                                </div>

                                <div className="col-md-4">
                                    <div><strong>Número de cuenta:</strong> {item.nroCuenta}</div>
                                    <div><strong>Tipo:</strong> {item.tipoCuenta}</div>
                                    <div><strong>CBU:</strong> {item.cbu}</div>
                                    <div><strong>Banco:</strong> {item.banco}</div>
                                </div>

                                <div className="col-md-2">
                                    {this.renderEstado(item.estado)}
                                </div>

                                {this.props.userType.isTesoreria && (
                                    <div className="col-md-3 d-flex gap-2">
                                        <button
                                            className="btn btn-sm btn-green"
                                            onClick={() => this.aceptar(item.id)}
                                        >
                                            ACEPTAR
                                        </button>

                                        <button
                                            className="btn btn-sm background-rojo-megatone waves-light mx-1"
                                            onClick={() => this.rechazar(item.id)}
                                        >
                                            RECHAZAR
                                        </button>
                                    </div>
                                )}

                            </div>
                        </div>
                    ))
                )}

                {!isLoading && listaDatosBancarios.length > 0 && pageCount > 1 ? (
                    <div className="d-flex justify-content-center mt-3 mb-4">
                        <SafeReactPaginate
                            previousLabel="Anterior"
                            nextLabel="Siguiente"
                            breakLabel="..."
                            breakClassName="break-me"
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName="pagination"
                            subContainerClassName="pages pagination"
                            activeClassName="active"
                            forcePage={currentPage - 1}
                        />
                    </div>
                ) : null}

            </div>

        );
    }
}
GestionDatosBancarios.propTypes = {
    userType: PropTypes.shape({
        isTesoreria: PropTypes.bool,
    }),
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    userId: state.general.userId,
});

export default connect(mapStateToProps)(GestionDatosBancarios);